import { CompVideoCore } from '../core/video/comp'

export const CompVideo = CompVideoCore
